import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from './notificationPopup.slice'
import { selectNotification } from './notificationPopup.selectors'
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog'

const { closePopup } = actions

export default function NotificationPopupContainer() {
	const { errorMessage, successMessage, title } =
		useSelector(selectNotification)
	const dispatch = useDispatch()
	const message = errorMessage || successMessage

	return (
		<AlertDialog open={!!message} onOpenChange={() => dispatch(closePopup())}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{title || (errorMessage ? 'Error' : 'Status')}</AlertDialogTitle>
					<AlertDialogDescription>{message}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogAction onClick={() => dispatch(closePopup())}>OK</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
